module.exports = __webpack_public_path__ + "static/sectionbefore-0b8b5ef40f5147b9b94690f9eb5d61cd.png";